(function () {
  'use strict';
  var FREE = 1000;
  var DISPLAY = { Blue: 'Navy Blue', Gray: 'Grey' };
  var SWATCH = { Black: '#1a1d1b', Brown: '#6b4a2f', Purple: '#a779c9', 'Navy Blue': '#1f2f4f', 'Sea Blue': '#49627c', Grey: '#8a8f8c' };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function disp(v) { return DISPLAY[v] || v; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function zar(n) { return 'R' + Math.round(n).toLocaleString('en-ZA', { maximumFractionDigits: 0 }).replace(/\u00a0/g, ' ').replace(/,/g, ' '); }
  function friendly(raw) {
    var low = String(raw).toLowerCase();
    if (low.indexOf('size') > -1) return 'Size';
    if (low.indexOf('color') > -1 || low.indexOf('colour') > -1) {
      if (low.indexOf('duowalk') > -1) return 'Leash colour';
      if (low.indexOf('prestigefit') > -1) return 'Harness colour';
      if (low.indexOf('leash') > -1) return 'Leash colour';
      if (low.indexOf('harness') > -1) return 'Harness colour';
      return 'Colour';
    }
    return raw;
  }

  var toastTimer;
  function toast(msg) {
    var t = $('#luxe-toast');
    if (!t) return;
    t.textContent = msg;
    t.style.opacity = '1';
    t.style.transform = 'translateY(0)';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateY(8px)'; }, 3000);
  }

  var cart = null;
  function openCart() {
    var c = $('#luxe-cart');
    c.classList.remove('pointer-events-none');
    c.setAttribute('aria-hidden', 'false');
    $('[data-cart-panel]', c).classList.remove('translate-x-full');
    $('[data-cart-close]', c).classList.remove('opacity-0');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var c = $('#luxe-cart');
    $('[data-cart-panel]', c).classList.add('translate-x-full');
    $('[data-cart-close]', c).classList.add('opacity-0');
    c.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { c.classList.add('pointer-events-none'); }, 300);
  }
  function icon(name, size) {
    var p = { x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>', minus: '<path d="M5 12h14"/>', plus: '<path d="M5 12h14"/><path d="M12 5v14"/>' }[name];
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }
  function renderCart() {
    if (!cart) return;
    var lines = cart.items;
    var subtotal = cart.items.reduce(function (s, i) { return s + (i.final_line_price / 100); }, 0);
    var bar = $('#luxe-cart-bar');
    bar.textContent = lines.length === 0
      ? 'Free delivery on all orders over ' + zar(FREE)
      : subtotal >= FREE ? "You've unlocked FREE delivery 🎉" : 'Add ' + zar(FREE - subtotal) + ' more for FREE delivery';
    var box = $('#luxe-cart-lines');
    if (lines.length === 0) {
      box.innerHTML = '<p class="py-12 text-center text-moss">Your cart is empty.</p>';
    } else {
      box.innerHTML = lines.map(function (l) {
        var opts = (l.options_with_values || []).map(function (o) { return disp(o.value); }).join(' · ');
        var img = l.image ? '<img src="' + esc(l.image) + '" alt="' + esc(l.product_title) + '" class="h-20 w-20 rounded-lg object-cover" loading="lazy">' : '<div class="size-20 shrink-0 rounded-lg bg-forest"></div>';
        return '<div class="flex gap-3 border-b border-hair pb-4">' + img +
          '<div class="flex-1"><div class="flex justify-between gap-2"><p class="font-display text-base font-bold leading-tight">' + esc(l.product_title) + '</p>' +
          '<button aria-label="Remove" data-line-remove="' + esc(l.key) + '" class="cursor-pointer text-moss hover:text-gold">' + icon('x', 16) + '</button></div>' +
          '<p class="mt-1 text-xs text-moss">' + esc(opts) + '</p>' +
          '<div class="mt-2 flex items-center justify-between"><div class="flex items-center rounded-full border border-line">' +
          '<button aria-label="Decrease" class="cursor-pointer p-2" data-line-qty="' + esc(l.key) + '" data-to="' + (l.quantity - 1) + '">' + icon('minus', 12) + '</button>' +
          '<span class="w-6 text-center text-sm">' + l.quantity + '</span>' +
          '<button aria-label="Increase" class="cursor-pointer p-2" data-line-qty="' + esc(l.key) + '" data-to="' + (l.quantity + 1) + '">' + icon('plus', 12) + '</button></div>' +
          '<span class="font-semibold text-gold">' + zar(l.final_line_price / 100) + '</span></div></div></div>';
      }).join('');
    }
    $('#luxe-cart-subtotal').textContent = zar(subtotal);
    $('#luxe-cart-checkout').disabled = lines.length === 0;
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = cart.item_count;
      b.classList.toggle('hidden', cart.item_count === 0);
    });
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; renderCart(); return c; });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; renderCart(); });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); }); } return r.json(); })
      .then(fetchCart).then(openCart)
      .catch(function (e) { toast(e.message); });
  }

  function colourImages(type, o) {
    var L = window.LUXE_FILES.leash, H = window.LUXE_FILES.harness;
    if (type === 'Bundle') return [L[o['Leash colour'] || 'Black'] || L.Black, H[o['Harness colour'] || 'Brown'] || H.Brown];
    if (type === 'Harness') return [H[o['Colour'] || 'Brown'] || H.Brown];
    return [L[o['Colour'] || 'Black'] || L.Black];
  }
  function renderPhoto(el, sources, alt) {
    el.style.gridTemplateColumns = sources.length > 1 ? 'repeat(2, minmax(0, 1fr))' : '';
    el.innerHTML = sources.map(function (src, i) {
      var a = sources.length > 1 ? alt + ' — ' + (i === 0 ? 'leash' : 'harness') : alt;
      return '<img src="' + esc(src) + '" alt="' + esc(a) + '" class="h-full min-h-0 w-full min-w-0 object-contain">';
    }).join('');
  }
  function initProduct(root) {
    if (root.__luxe) return;
    root.__luxe = true;
    var data = JSON.parse($('[data-product]', root).textContent);
    var type = root.getAttribute('data-type');
    var title = root.getAttribute('data-title');
    var price = Number(root.getAttribute('data-price')) / 100;
    var rawNames = (data.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var groups = rawNames.map(function (raw, i) {
      var vals = [];
      data.variants.forEach(function (v) { var x = disp(v['option' + (i + 1)]); if (vals.indexOf(x) < 0) vals.push(x); });
      return { raw: raw, name: friendly(raw), idx: i + 1, values: vals };
    });
    var sel = {};
    groups.forEach(function (g) { sel[g.name] = g.values[0]; });
    var qty = 1, img = 0;
    var hasGallery = root.hasAttribute('data-gallery-mode');
    var photo = $('[data-photo]', root), thumbs = $('[data-thumbs]', root), optBox = $('[data-options]', root), addBtn = $('[data-add]', root);
    var qtyVal = $('[data-qty-val]', root);

    function variant() {
      return data.variants.filter(function (v) {
        return groups.every(function (g) { return disp(v['option' + g.idx]) === sel[g.name]; });
      })[0];
    }
    function gallery() {
      var g = [colourImages(type, sel)];
      (data.images || []).slice(0, 3).forEach(function (s) { g.push([typeof s === 'string' ? s : s.src]); });
      return g;
    }
    function render() {
      var gal = gallery();
      renderPhoto(photo, hasGallery ? (gal[img] || gal[0]) : gal[0], title);
      if (thumbs) {
        thumbs.innerHTML = gal.map(function (srcs, i) {
          var inner = srcs.map(function (s) { return '<img src="' + esc(s) + '" alt="" class="h-full min-h-0 w-full min-w-0 object-contain">'; }).join('');
          return '<button type="button" data-thumb="' + i + '" aria-label="View image ' + (i + 1) + '" class="product-colour-photo grid aspect-square h-auto cursor-pointer overflow-hidden rounded-xl border-2 p-0 transition ' + (img === i ? 'border-gold' : 'border-transparent opacity-70 hover:opacity-100') + '"' + (srcs.length > 1 ? ' style="grid-template-columns:repeat(2,minmax(0,1fr))"' : '') + '>' + inner + '</button>';
        }).join('');
      }
      optBox.innerHTML = groups.map(function (g) {
        var isColour = g.name.toLowerCase().indexOf('colour') > -1;
        var btns = g.values.map(function (v) {
          var on = sel[g.name] === v;
          if (isColour) {
            return '<button type="button" aria-label="' + esc(v) + '" title="' + esc(v) + '" aria-pressed="' + on + '" data-opt="' + esc(g.name) + '" data-val="' + esc(v) + '" class="inline-flex size-9 cursor-pointer items-center justify-center rounded-full border-2 p-0 ring-offset-2 ring-offset-deep transition ' + (on ? 'border-gold ring-2 ring-gold' : 'border-line hover:border-gold') + '" style="background-color:' + (SWATCH[v] || '#888') + '"></button>';
          }
          return '<button type="button" aria-pressed="' + on + '" data-opt="' + esc(g.name) + '" data-val="' + esc(v) + '" class="inline-flex h-10 min-w-12 cursor-pointer items-center justify-center rounded-full border px-4 font-mono text-sm transition ' + (on ? 'border-gold bg-gold text-deep' : 'border-line text-cream hover:border-gold') + '">' + esc(v) + '</button>';
        }).join('');
        return '<fieldset><legend class="eyebrow mb-3">' + esc(g.name) + ': <span class="text-cream">' + esc(sel[g.name]) + '</span></legend><div class="flex flex-wrap gap-2">' + btns + '</div></fieldset>';
      }).join('');
      var v = variant();
      if (addBtn) {
        if (!addBtn.hasAttribute('data-orig')) addBtn.setAttribute('data-orig', addBtn.textContent);
        var out = !v || !v.available;
        var base = addBtn.getAttribute('data-label');
        addBtn.disabled = out;
        if (out) addBtn.textContent = 'Sold out';
        else if (base) addBtn.textContent = base + zar(price * qty);
        else addBtn.textContent = addBtn.getAttribute('data-orig');
      }
      if (qtyVal) qtyVal.textContent = qty;
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-opt]');
      if (o && root.contains(o)) {
        sel[o.getAttribute('data-opt')] = o.getAttribute('data-val');
        if (o.getAttribute('data-opt').toLowerCase().indexOf('colour') > -1) img = 0;
        render(); return;
      }
      var t = e.target.closest('[data-thumb]');
      if (t) { img = Number(t.getAttribute('data-thumb')); render(); return; }
      if (e.target.closest('[data-qty-dec]')) { qty = Math.max(1, qty - 1); render(); return; }
      if (e.target.closest('[data-qty-inc]')) { qty += 1; render(); return; }
      var a = e.target.closest('[data-add]');
      if (a) { var v = variant(); if (v && v.available) addToCart(v.id, qty); }
    });
    render();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { changeLine(rm.getAttribute('data-line-remove'), 0); return; }
    var q = e.target.closest('[data-line-qty]');
    if (q) { changeLine(q.getAttribute('data-line-qty'), Math.max(0, Number(q.getAttribute('data-to')))); return; }
    if (e.target.closest('#luxe-cart-checkout')) { window.location.href = '/checkout'; return; }
    if (e.target.closest('[data-account]')) { toast('Accounts are coming soon'); return; }
    var mb = e.target.closest('[data-menu-btn]');
    if (mb) { var m = $('[data-menu]'); m.classList.toggle('hidden'); m.classList.toggle('flex'); return; }
    var pv = e.target.closest('[data-prev]'), nx = e.target.closest('[data-next]');
    if (pv || nx) {
      var tr = $('[data-track]', (pv || nx).closest('[data-carousel]'));
      tr.scrollBy({ left: (nx ? 1 : -1) * tr.clientWidth, behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  var io;
  function observeReveals(scope) {
    $$('.reveal', scope).forEach(function (el) { if (io) io.observe(el); });
  }
  function showReveals(scope) {
    $$('.reveal', scope).forEach(function (el) { el.classList.add('is-visible'); });
  }
  function init() {
    $$('[data-luxe-product]').forEach(initProduct);
    fetchCart();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    observeReveals(document);
    if (window.Shopify && window.Shopify.designMode) showReveals(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-luxe-product]', e.target).forEach(initProduct);
    if (e.target.matches && e.target.matches('[data-luxe-product]')) initProduct(e.target);
    showReveals(e.target);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () {
    requestAnimationFrame(function () { requestAnimationFrame(function () { document.documentElement.classList.remove('luxe-wait'); }); });
  });
})();